import React, { FC } from 'react'

import {
  RangeValuesFilter,
  RangeValuesProps,
} from '@new/__global/components/Filters/FiltersVariations/Range'
import { filtersLabels } from '@new/domains/bookings/screens/bookingsList/utils/labels'

import { FiltersSharedProps } from './Filters.types'

interface Range {
  from?: string
  to?: string
}

interface BathroomsRangeFilterProps extends FiltersSharedProps {
  initialValue?: Range
  onChange: (value?: Range) => void
}

export const BathroomsRangeFilter: FC<BathroomsRangeFilterProps> = ({
  initialValue,
  onChange,
  ...props
}) => {
  const handleBathroomsRangeChange = ({ fromRangeValue, toRangeValue }: RangeValuesProps) => {
    onChange({ from: fromRangeValue, to: toRangeValue })
  }

  return (
    <RangeValuesFilter
      title={filtersLabels.bathroomsRange}
      fromInputTypeIndicator="Min"
      toInputTypeIndicator="Max"
      shouldDisplayFiltersOnSameLine
      onChange={handleBathroomsRangeChange}
      rangeValues={{
        fromRangeValue: initialValue?.from,
        toRangeValue: initialValue?.to,
      }}
      placeholder={{ from: '0', to: '1' }}
      {...props}
    />
  )
}
